import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classNames from 'classnames';
import { toEuros } from '../../../../lib/numbers';

const useStyles = createUseStyles((theme: Theme) => ({
  amount: {
    ...theme.fonts.label,
  },
  positive: {
    ...theme.fonts.label,
    color: theme.colors.greenAccessible,
  },
}));

interface Props {
  amount: number;
}

export const Amount = ({ amount }: Props) => {
  const classes = useStyles();

  return (
    <div
      className={classNames(classes.amount, {
        [classes.positive]: amount > 0,
      })}
    >
      {amount > 0 ? '+' : ''}
      {toEuros(amount)}
    </div>
  );
};
